/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { HashicorpCloudVagrant20220930BoxState as States } from '@clients/cloud-vagrant-box-registry';
import Component from '@glimmer/component';
const ICONS = {
  [States.AVAILABLE]: 'check',
  [States.NOVERSIONS]: 'pin',
  [States.NORELEASEDVERSIONS]: 'pin',
  [States.NOPROVIDERS]: 'socket',
  [States.INACTIVEORUNSPECIFIED]: 'bug'
};
const COLORS = {
  [States.AVAILABLE]: 'success',
  [States.NOVERSIONS]: 'neutral',
  [States.NORELEASEDVERSIONS]: 'warning',
  [States.NOPROVIDERS]: 'warning',
  [States.INACTIVEORUNSPECIFIED]: 'critical'
};
export default class extends Component {
  get state() {
    return this.args.box?.state;
  }
  get icon() {
    return ICONS[this.state ?? ''];
  }
  get color() {
    return COLORS[this.state ?? ''];
  }
}